import {
  PropertyType,
  PropertyUse,
  StateAbbreviation,
  Veteran,
} from './generated/graphql-types'

export interface ServicerLeads {
  id: number
  uuid: string
  loan_number: string
  first_name: string
  last_name: string
  email: string
  phone: string
  address: string
  source: ServicerLeadSource
  credit_score: number
  current_monthly_payment: number
  current_rate: number
  loan_amount: number
  loan_to_value: number
  property_type: PropertyType
  property_use: PropertyUse
  property_value: number
  remaining_balance: number
  remaining_months: number
  state: StateAbbreviation
  veteran: Veteran
  zip_code: string
  created_at: Date
  updated_at: Date
  property_tax?: number
  escrow_short_or_over?: number
  escrow_lien_amount?: number
  flood_insurance?: number
  homeowners_insurance?: number
  pmi_mi_payment_amount_monthly?: number
}

export enum ServicerLeadSource {
  Test = 'test',
  Annaly = 'annaly',
  ServiceMac = 'servicemac',
  Haven = 'haven',
}

export const APPLY_SUPPORTED_SERVICER_SOURCES: readonly ServicerLeadSource[] = [
  ServicerLeadSource.Annaly,
]

export function isServicerSourceSupportedForApply(
  source: string | null | undefined
): boolean {
  return APPLY_SUPPORTED_SERVICER_SOURCES.includes(source as ServicerLeadSource)
}

export enum ServicerLeadSubServicer {
  LoanCare = 'LoanCare',
}

export enum ServicerLeadMSROwner {
  Annaly = 'Annaly',
}

export enum LoanMatchDataSource {
  ServicerLeads = 'ServicerLeads',
  SageAggregate = 'SageAggregate',
  PricingTool = 'PricingTool',
}

// Loan Match Batch Processing Types

export const LoanMatchJobType = {
  Nightly: 'nightly',
  OnDemand: 'on-demand',
} as const

export type LoanMatchJobType =
  (typeof LoanMatchJobType)[keyof typeof LoanMatchJobType]

export interface LoanMatchBatchData {
  batchId: string
  leadIds: number[]
  batchNumber: number
  totalBatches: number
  sources?: string[] // Optional for logging context
  jobType?: LoanMatchJobType
}

export interface LoanMatchBatchResult {
  leadId: number
  leadUuid?: string
  source: string
  success: boolean
  error?: any
  processingTime: number
  leadIndex: number
}

export interface LoanMatchBatchSummary {
  batchId: string
  batchNumber: number
  totalBatches: number
  leadCount: number
  successCount: number
  errorCount: number
  totalDuration: number
  sources: string[]
}

export interface LoanMatchErrorDetail {
  reason: string
  loanType?: string
  field?: string
}

export interface LoanMatchErrors {
  errors: LoanMatchErrorDetail[]
}
